import { baseUrl, headers, jwtHeaders, jwtFormDataHeaders } from '../common/data';

export const fetchAllBillings = async (branchId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/billing/getbranchwisebill/${branchId}${queryParams ? queryParams : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();

  return resData;
};

export const fetchBillAnalytics = async (branchId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/billing/combinedbillapi/${branchId}${queryParams ? queryParams : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response?.json();
  return resData;
};

export const fetchBillById = async (billId, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/billing/getparticularbill/${billId}${branchId ? branchId : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const fetchTotalSales = async (branchId) => {
  const response = await fetch(`${baseUrl}/api/billing/gettotalsalesbranchwise/${branchId}`, {
    method: 'GET',
    headers: jwtHeaders(),
    redirect: 'follow',
  });
  const resData = await response?.json();

  return resData;
};

export const createBilling = async (data) => {
  const response = await fetch(`${baseUrl}/api/billing/create`, {
    method: 'POST',
    body: data,
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

// export const deleteBilling = async (id, branchId) => {
//   const response = await fetch(
//     `${baseUrl}/api/billing/deletebill/${id}${branchId ? branchId : ''}`,
//     {
//       method: 'DELETE',
//       headers: jwtHeaders(),
//     },
//   );
//   const resData = await response?.json();

//   return resData;
// };

// new code 
export const deleteBilling = async (id, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/billing/deletebill?branchId=${branchId}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...jwtHeaders(),
      },
      body: JSON.stringify({
        ids: [id],
        status: false,
      }),
    },
  );

  const resData = await response.json();
  return resData;
};

export const fetchSalesExpenseSummary = async (branchId, queryParams = '') => {
  const response = await fetch(
    `${baseUrl}/api/billing/getSalesExpenseSummary/${branchId}${queryParams}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    },
  );
  const resData = await response.json();
  return resData;
};


export const updateBill = async (billId, branchId, data) => {
  const response = await fetch(
    `${baseUrl}/api/billing/updatebill/${billId}${branchId ? branchId : ''}`,
    {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();

  return resData;
};

export const clearRemainingAmount = async (billId, branchId, data) => {
  const response = await fetch(
    `${baseUrl}/api/billing/updateprevious/${billId}${branchId ? branchId : ''}`,
    {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();

  return resData;
};

export const fetchPackageBills = async (branchId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/billing/packagebills/${branchId}${queryParams ? queryParams : ''}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });

  const resData = await response.json();

  return resData;
};

//new code 
export const deletePackagebill = async(id,branchId) =>{
  const response = await fetch(
    `${baseUrl}/api/billing/deletepackagebills?branchId=${branchId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...jwtHeaders(),
      },
      body: JSON.stringify({
        ids: [id],
        status: false,
      }),
    },
  );
  const resData = await response.json();
  return resData;
};

export const fetchPackageBillById = async (pkgBillId, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/billing/singlepkgbill/${pkgBillId}?branchId=${branchId}`,  
    {
      method: 'GET',  // GET method
      headers: jwtHeaders(),  // Your headers
    }
  );
  
  const resData = await response?.json();
  return resData;
};

export const getGstData = async (activeBranchId) => {
  const response = await fetch(
    `${baseUrl}/api/billing/gstbilldetails/${activeBranchId}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });

  const resData = await response.json();

  return resData;
};


// **********************************DRAFT BILL APIS************************************

export const fetchDraftBill = async (branchId) => {
  try {
    const response = await fetch(`${baseUrl}/api/billing/alldraftbill?branchId=${branchId}`, {
      method: 'GET',
      headers: jwtHeaders(),
      redirect: 'follow',
    });

    if (!response.ok) {
      throw new Error(`Error fetching draft bills: ${response.statusText}`);
    }

    const resData = await response.json();
    console.log('Draft Bill API Response:', resData); 
    return resData;
  } catch (error) {
    console.error('Error in fetchDraftBill:', error); 
    return { status: 'error', message: error.message };
  }
};

export const createDraftBilling = async (data) => {
  const response = await fetch(`${baseUrl}/api/billing/createdraftbill`, {
    method: 'POST',
    body: data,
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

export const fetchSingleBill = async (queryParams) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/billing/singledraftbill${queryParams ? queryParams : ''}`,
      {
        method: 'GET',
        headers: jwtHeaders(),
      }
    );
    
    const resData = await response.json();
    return resData;
    
  } catch (error) {
    console.error('Error fetching single bill:', error);
    throw error;
  }
};

export const deleteDraftBill = async (billId, branchId) => {
  const response = await fetch(
    `${baseUrl}/api/billing/deletedraftbill?billId=${billId}&branchId=${branchId}`,
    {
      method: 'DELETE', // Using DELETE method
      headers: {
        'Content-Type': 'application/json',
        ...jwtHeaders(),
      },
    }
  );
  const resData = await response.json();
  return resData;
};

export const fetchPackageAndMembershipBills = async (branchId, queryParams = '') => {
  try {
    const response = await fetch(
      `${baseUrl}/api/billing/packagebilloverview?branchId=${branchId}${queryParams}`,
      {
        method: 'GET',
        headers: jwtHeaders(),
        redirect: 'follow',
      }
    );
    const resData = await response.json();
    return resData;
  } catch (error) {
    console.error('Error fetching package/membership bills:', error);
    return { statusCode: 500, message: 'Internal Error' };
  }
};


export const createManyBills = async (id, data) => {
  const response = await fetch(`${baseUrl}/api/billing/bulkbillupload/${id}`, {
    method: 'POST',
    body: data,
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

// ****************************Templates******************************

export const getWhatsAppTemplates = async (ownerId) => {
  const id = ownerId || JSON.parse(localStorage.getItem('salon-admin'));
  const response = await fetch(`${baseUrl}/api/client/yoursalontemplates/${id}`, {
    method: 'GET',
    headers: jwtHeaders(),
    redirect: 'follow',
  });

  // if (response?.status === 401) {
  //   logoutUtil();
  // }

  const resData = await response?.json();
  return resData;
};

export const sendBulkWhatsApp = async (data, activeBranchId) => {
  console.log(jwtHeaders());

  // Check if data includes a headerFile (File object from template dialog)
  const { headerFile, ...restData } = data;

  let body;
  let reqHeaders;

  if (headerFile) {
    // Build FormData for multipart/form-data request
    const formData = new FormData();
    formData.append('header1', headerFile);
    formData.append('numbers', JSON.stringify(restData.numbers));
    formData.append('template_name', restData.template_name);

    // Append all other fields (body vars, button vars, etc.)
    Object.keys(restData).forEach((key) => {
      if (key !== 'numbers' && key !== 'template_name') {
        formData.append(key, restData[key]);
      }
    });

    body = formData;
    reqHeaders = jwtFormDataHeaders(); // No Content-Type so browser sets multipart boundary
  } else {
    body = JSON.stringify(data);
    reqHeaders = jwtHeaders();
  }

  const response = await fetch(
    `${baseUrl}/api/client/yoursalonbulkmessage?branchId=${activeBranchId}`,
    {
      method: 'POST',
      body: body,
      headers: reqHeaders,
    }
  );

  const resData = await response.json();
  return resData;
};
